import { RoleHTMLProps, RoleOptions, useRole } from "reakit";
import { useForkRef } from "reakit-utils";
import { mergeProps } from "@react-aria/utils";

import { createComponent, createHook } from "../system";

import { SLIDER_TRACK_KEYS } from "./__keys";
import { SliderStateReturn } from "./SliderState";

export type SliderTrackOptions = RoleOptions &
  Pick<SliderStateReturn, "trackProps" | "trackRef">;

export type SliderTrackHTMLProps = RoleHTMLProps;

export type SliderTrackProps = SliderTrackOptions & SliderTrackHTMLProps;

export const useSliderTrack = createHook<
  SliderTrackOptions,
  SliderTrackHTMLProps
>({
  name: "SliderTrack",
  compose: useRole,
  keys: SLIDER_TRACK_KEYS,

  useProps(options, htmlProps) {
    const { trackProps, trackRef } = options;
    const { ref: htmlRef, ...restHtmlProps } = htmlProps;

    return mergeProps(trackProps, {
      ref: useForkRef(trackRef, htmlRef),
      ...restHtmlProps,
    });
  },
});

export const SliderTrack = createComponent({
  as: "div",
  memo: true,
  useHook: useSliderTrack,
});
